import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import UserDateTimezone from '../../../components/user-date-timezone-format/index';
import { messages } from '../messages';

const DelegationDate = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));

  if (!fulfillment?.createDateTime) {
    return '';
  }

  return <UserDateTimezone dateTime={fulfillment.createDateTime} />;
};

DelegationDate.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const delegationDate = {
  getMessageDescriptor: () => messages.delegationDate,
  name: <FormattedMessage {...messages.delegationDate} />,
  id: 'delegationDate',
  render: (data) => <DelegationDate fulfillmentId={data.id} />,
};
